import React from 'react'
import { Icon } from '@chakra-ui/react'

export function IconDiscovery(rest) {
  return (
    <Icon viewBox="0 0 32 32" {...rest}>
      <g
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        transform="matrix(1,0,0,1,7.10543e-15,0.331402)"
      >
        <g transform="matrix(1.75,0,0,1.75,2,2)">
          <path d="M16,5.716L10.248,5.226L8,0L5.752,5.234L0,5.716L4.368,9.45L3.056,15L8,12.055L12.944,15L11.64,9.45L16,5.716ZM14.592,6.169L11.004,9.242L12.08,13.82C12.08,13.82 8,11.39 8,11.39L3.922,13.819C3.922,13.819 5.004,9.242 5.004,9.242L1.412,6.171C1.412,6.171 6.142,5.775 6.142,5.775L8,1.447C8,1.447 9.858,5.767 9.858,5.767L14.592,6.169Z" />
        </g>
        <g transform="matrix(1.75,0,0,1.75,2,2)">
          <path d="M8,10.579L8,3.237L9.368,6.426L12.872,6.726L10.216,9L11.016,12.379L8,10.579ZM8.571,10.255L8.571,6.019C8.571,6.019 8.978,6.966 8.978,6.966L11.464,7.179C11.464,7.179 9.58,8.793 9.58,8.793L10.149,11.196L8.571,10.255Z" />
        </g>
      </g>
    </Icon>
  )
}
